module.exports = __webpack_public_path__ + "static/irene-647cb539bc49aabac03a5e927808039c.jpg";